import { Button, Icon } from "@aidkitorg/component-library";
import { IconName } from "@aidkitorg/component-library/src/Icon";
import React, { SetStateAction, useState } from "react";
import { MetricComponentConfig } from "./MetricComponentConfig";
import { BarChartComponentConfig } from "./BarChartComponentConfig";
import { PieChartComponentConfig } from "./PieChartComponentConfig";
import { MapComponentConfig } from "./MapComponentConfig";

type DashboardComponent = {
  key: 'metric' | 'bar_chart' | 'pie_chart' | 'map' | 'report',
  name: string,
  subtitle: string,
  icon: IconName,
  onClick: React.MouseEventHandler<HTMLButtonElement> 
}

type DashboardComponentOptionsProps = {
  options: Array<DashboardComponent>
}

const DashboardComponentOptions: React.FC<DashboardComponentOptionsProps> = ({ options }) => {
  return (
    <>
      {options.map((component, idx) => (
        <div key={idx}>
          <Button 
            className="border !w-full !justify-start"
            variant="secondary"
            onClick={component.onClick}
          >
            <div className="flex items-center gap-x-2">
              <div>
                <Icon name={component.icon} role="decorative"/>
              </div>
              <div className="text-left">
                <div>
                  {component.name}
                </div>
                <div className="text-gray-700 font-normal">
                  {component.subtitle}
                </div>
              </div>
            </div>
          </Button>
        </div>
      ))}
    </>
  )
}

export type CreateComponentProps = {
  setDisplayMode: React.Dispatch<SetStateAction<string>>
}

export const CreateDashboardComponentTab = () => {
  const [displayMode, setDisplayMode] = useState<DashboardComponent['key'] | 'create'>('create')

  const DASHBOARD_COMPONENT_OPTIONS: Array<DashboardComponent> = [
    {
      key: 'metric',
      name: 'Metric',
      subtitle: 'Display a single number or KPI',
      icon: 'CurrencyDollarIcon',
      onClick: () => setDisplayMode('metric')
    },
    {
      key: 'bar_chart',
      name: 'Bar Chart',
      subtitle: 'Compare values across categories',
      icon: 'ChartBarIcon',
      onClick: () => setDisplayMode('bar_chart')
    },
    {
      key: 'pie_chart',
      name: 'Pie Chart',
      subtitle: 'Show composition of a whole',
      icon: 'ChartPieIcon',
      onClick: () => setDisplayMode('pie_chart')
    },
    {
      key: 'map',
      name: 'Map',
      subtitle: 'Visualize geographic data',
      icon: 'MapIcon',
      onClick: () => setDisplayMode('map')
    },
    {
      key: 'report',
      name: 'Add Report',
      subtitle: 'Create a detailed data table',
      icon: 'TableCellsIcon',
      onClick: () => setDisplayMode('report')
    }
  ]

  return (
    <div className="flex flex-col gap-y-2 p-2"> 
      {displayMode === 'create' && <DashboardComponentOptions options={DASHBOARD_COMPONENT_OPTIONS} />}
      {displayMode === 'metric' && <MetricComponentConfig setDisplayMode={() => setDisplayMode('create')} />}
      {displayMode === 'bar_chart' && <BarChartComponentConfig setDisplayMode={() => setDisplayMode('create')} />}
      {displayMode === 'pie_chart' && <PieChartComponentConfig setDisplayMode={() => setDisplayMode('create')} />}
      {displayMode === 'map' && <MapComponentConfig setDisplayMode={() => setDisplayMode('create')}/>}
    </div>
  )
}